<template>
  <main class="main cus_regionSelected" role="main">
    <div class="main_con">
      <div class="con_ttl bot24">우리동네는 하나만 선택해 주세요.</div>
      <div class="location_confirm">
        <div class="region_btn pnt" @click="gotoRegion">
          <div class="region_plus_img">
            <img
              :src="require('@/assets/front/images/new/i_plus_region.svg')"
              alt=""
            />
          </div>
          <div class="region_plus_txt">동네 추가하기</div>
        </div>
        <div class="my_dong_area">
          <div
            class="my_dong pnt"
            :class="{ on: selectedAreaId === item.areaId }"
            v-for="(item, index) in list"
            :key="index"
            @click.prevent="selectArea(item)"
          >
            <div class="area_name">{{ item.areaName }}</div>
            <button class="i_x_l3" @click.stop="removeList(item)"></button>
          </div>
        </div>
      </div>
    </div>
    <div class="msg">
      Tip. 우리동네에 매장이 없다면 주변 번화가로 변경해보세요
    </div>
    <div class="btm_btn">
      <div class="btn_wrap">
        <button class="btn" :disabled="selectedAreaId === 0" @click="start">
          {{ btnText }}
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import {
  isApp,
  sleep,
  clearLocation,
  nativeLocation,
  nativeGoToSetting,
} from '@common/lib/common/utils';

export default {
  name: 'RegionSelected',
  data() {
    return {
      show: true,
      fromPage: undefined,
      isAreaValue: '',
      selectedAreaId: 0,
      selectedAreaName: '',
      selectedAreaFullName: '',
      selectedCodeType: '',
      list: [],
    };
  },
  async created() {
    this.fromPage = this.$route.query.from;
    this.isAreaValue = this.$route.query.isAreaValue;
    if (isApp()) {
      nativeLocation();
    }
  },
  mounted() {
    try {
      this.selectedAreaId = Number(this.$route.query.areaId);
      this.selectedAreaName = this.$route.query.areaName;
      this.selectedAreaFullName = this.$route.query.areaFullName;
      this.selectedCodeType = this.$route.query.codeType;
    } catch (e) {
      console.warn(e);
    }

    let history = localStorage.getItem('areaHistory');
    if (!history) {
      history = new Array();
    } else {
      history = JSON.parse(history);
    }
    const idx = history.findIndex(h => h.areaId === this.selectedAreaId);
    // 히스토리에 없으면
    if (idx < 0) {
      let data = {
        areaId: this.selectedAreaId,
        areaName: this.selectedAreaName,
        areaFullName: this.selectedAreaFullName,
        codeType: this.selectedCodeType,
        temp: true, // 임시저장. 동네 설정시 최종 저장한다.
      };
      // fromPage가 있고(매장리스트, 마이페이지), 기존데이터가 없으면 저장한다.
      if (history.length === 0 && this.fromPage !== undefined) {
        delete data.temp;
        history.splice(0, 0, data);
        localStorage.setItem('areaHistory', JSON.stringify(history));
      } else {
        history.splice(0, 0, data);
      }
    }

    this.list = history;
  },
  computed: {
    btnText() {
      var btnText = '적용하기';
      // if (this.$route.query.from === 'MyPage') {
      //   btnText = '적용하기';
      // } else if (this.$route.query.from === 'ShopList') {
      //   btnText = '시작하기';
      // } else if (this.$route.query.from === 'Internet') {
      //   btnText = '선택하기';
      // }
      return btnText;
    },
  },
  methods: {
    ...userMapActions([userTypes.FETCH_USER, userTypes.UPDATE_AREA_ME]),
    gotoRegion() {
      this.$router.push({
        name: 'Auth.Region',
        query: { from: this.$route.query.from ? this.$route.query.from : '' },
      });
    },
    selectArea(item) {
      this.selectedAreaId = item.areaId;
      this.selectedAreaName = item.areaName;
      this.selectedAreaFullName = item.areaFullName;
      this.selectedCodeType = item.codeType;
    },
    removeList(item) {
      const idx = this.list.findIndex(h => h.areaId === item.areaId);
      if (idx > -1) {
        this.list.splice(idx, 1);
        const newList = this.list.filter(f => !f.temp);
        localStorage.setItem('areaHistory', JSON.stringify(newList));
        this.selectedAreaId = 0;
        this.selectedAreaName = '';
        this.selectedAreaFullName = '';
        this.selectedCodeType = '';
      }
    },
    async start() {
      // 동네 정보 저장후 우리동네 매장 페이지로 이동
      const payload = {
        areaId: this.selectedAreaId,
        areaName: this.selectedAreaName,
        areaFullName: this.selectedAreaFullName,
        codeType: this.selectedCodeType || 'a',
      };
      // alert(this.$route.query.from);
      //console.log(payload);
      // await this[userTypes.UPDATE_AREA_ME](payload).then(() => {
      if (this.$route.query.from === 'Internet') {
        if (this.isAreaValue == 'No') {
          await this[userTypes.UPDATE_AREA_ME](payload).then(() => {});
        }
        localStorage.setItem('internetArea', JSON.stringify(payload));
        this.$router.replace({ name: 'InternetCommerce.RequestForm' });
      } else if (this.$route.query.from === 'MyInternet') {
        if (this.isAreaValue == 'No') {
          await this[userTypes.UPDATE_AREA_ME](payload).then(() => {});
        }
        localStorage.setItem('internetArea', JSON.stringify(payload));
        this.$router.replace({
          name: 'InternetCommerce.RequestForm',
          query: {
            mode: 'MY_INTERNET',
          },
        });
      } else if (this.$route.query.from === 'Mobile_1') {
        if (this.isAreaValue == 'No') {
          await this[userTypes.UPDATE_AREA_ME](payload).then(() => {});
        }
        localStorage.setItem('mobileArea_1', JSON.stringify(payload));
        this.$router.replace({ name: 'Mobile.RequestForm' });
      } else if (this.$route.query.from === 'Mobile_2') {
        if (this.isAreaValue == 'No') {
          await this[userTypes.UPDATE_AREA_ME](payload).then(() => {});
        }
        localStorage.setItem('mobileArea_2', JSON.stringify(payload));
        this.$router.replace({ name: 'Mobile.RequestForm' });
      } else if (this.$route.query.from === 'Skylife') {
        localStorage.setItem('skylifeArea', JSON.stringify(payload));
        this.$router.replace({ name: 'InternetCommerce.Skylife' });
      } else if (this.$route.query.from === 'Knowhow') {
        localStorage.setItem('knowhow-area', JSON.stringify(payload));
        this.$router.replace({ name: 'Knowhow.Write' });
      } else if (this.$route.query.from === 'ShopList') {
        await this[userTypes.UPDATE_AREA_ME](payload).then(() => {
          this.$router.push({ name: 'Shop.List' });
        });
      } else if (this.$route.query.from === 'Main') {
        await this[userTypes.UPDATE_AREA_ME](payload).then(() => {
          this.$router.push({ name: 'Home' });
        });
      } else if (this.$route.query.from === 'MyPage') {
        await this[userTypes.UPDATE_AREA_ME](payload).then(() => {
          this.$router.push({ name: 'MyPage.Main' });
        });
      } else {
        this.$router.push({ name: 'Home' });
      }
      // });
    },
  },
};
</script>
